import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CultureService } from '../services/culture.service';
import { LanguageCultureCodes } from '../constants/scheduling.constant';

@Pipe({
  name: 'date',
  pure: false
})

export class LocalizedDatePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
    private cultureService: CultureService
  ) {

  }

  transform(value: any, pattern: string = 'mediumDate'): any {
    let language = LanguageCultureCodes.find(lang =>
      this.translateService.currentLang === lang.key
    );

    const datePipe: DatePipe = new DatePipe(!!language ? this.cultureService.mapLanguageCodeToISO(language.culture) : this.translateService.defaultLang);
    return datePipe.transform(value, pattern);
  }

}